import API from "../Services/API";
import { hashCode, toQueryString } from "../Services/helpers";
import Model from "./Model"

const useJobInvoiceChart = (alwaysRefresh = false, dateRange, groupBy) => {
    return Model({
        defaultData: null,
        stateKey: 'customer-job-invoice-chart',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/customers/chart?dateRange=${dateRange}&${groupBy ? 'groupBy=' + groupBy : ''}`),
        returnDataKey: 'chart',
        defaultLoadingError: 'Sorry, there was an error loading the chart.',
    })
}

const useReport = (path, args = null, alwaysRefresh = true) => {
    return Model({
        stateKey: ['report', path, args],
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(path+'?'+toQueryString(args)),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}

const useProfitAndLoss = (dateRange, alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'report',
        stateKey: ['reports', 'profit-and-loss', dateRange],
        fetchData: () => API.get('/reports/profitAndLoss?dateRange=' + dateRange),
        defaultLoadingError: 'Sorry, there was an error loading the profit and loss report.',
    });
}

const useAvailableMetrics = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'availableMetrics',
        stateKey: ['reports', 'availableMetrics'],
        fetchData: () => API.get('/reports/metrics'),
    });
}

const useMetrics = (alwaysRefresh = false, metrics) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'metrics',
        stateKey: ['reports', 'metrics', hashCode(metrics)],
        fetchData: () => API.post('/reports/metrics', metrics),
    });
}

/*
const useJobsReport = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'jobs-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/jobs/report`),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}

const useJobsWorkerReport = (alwaysRefresh = true, args = {}) => {
    return Model({
        stateKey: 'jobs-worker-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/jobs/report/workers?`+toQueryString(args)),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}

const useForecastReport = (alwaysRefresh = true, args = {}) => {
    return Model({
        stateKey: 'jobs-forecast-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/jobs/report/forecast?`+toQueryString(args)),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}
 */
export {
    useJobInvoiceChart,
    useReport,
    useProfitAndLoss,
    useAvailableMetrics,
    useMetrics,
};
